import { useContext } from 'react';
import { FiltersContext } from '@contexts/FiltersContext';

export const useFilters = () => {
  const context = useContext(FiltersContext);

  if (!context) {
    throw new Error(
      'useFilters deve ser utilizado dentro de um FiltersProvider'
    );
  }

  return context;
};
